// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature_root__2-T97","icon":"Feature_icon__2xx1X","text":"Feature_text__3RSfK"};